import { Article } from 'app/timeline/models/article.model';

export function articleRouteUrl(article: Article) {
  if (article.article_sponsored) {
    return ['/article-partenariat', article.article_slug];
  }

  if (article.is_free) {
    return ['/article-gratuit', article.article_slug];
  }

  return ['/article', article.article_slug];
}

export function removeKeywords(article: Article) {
  if (!article.article_content) {
    return { ...article };
  }
  const content = article.article_content.replace(/(<a(?: \w+="[^"]+")* class="article_keyword"(?: \w+="[^"]+")*>)([^<]*)(<\/a>)/g, '$2');
  return { ...article, article_content: content };
}

export function getExcerpt(article: Article): string {
  if (!article.article_content || article.article_content.length <= 100) {
    return article.article_content;
  }

  const articleExcerpt = article.article_content.slice(0, 100);
  return articleExcerpt.substr(0, articleExcerpt.lastIndexOf(' ')).concat(' ...');
}

export function getExcerptNoHTML(article: Article): string {
  if (article.article_content && article.article_content.length <= 100) {
    return article.article_content.replace(/(<([^>]+)>)/ig,"");
  }
  if (article.article_content && article.article_content.length > 100){
    const articleExcerpt = article.article_content.slice(0, 100);
    return articleExcerpt.substr(0, articleExcerpt.lastIndexOf(' ')).concat(' ...').replace(/(<([^>]+)>)/ig,"");
  }
}

export function getImage(article: Article): string {
  if (article.image_url) {
    return article.image_url;
  }

  if (article.carrousel && article.carrousel.length > 0) {
    return article.carrousel[0].image_url;
  }

  return '';
}

export function sharedItems(newspaperSubname: string): string[] {
  if (newspaperSubname === 'mquo' || newspaperSubname === 'lepq' || newspaperSubname === 'mlwk' || newspaperSubname === 'mlne' || newspaperSubname === 'mquovideo') {
    return ['email'];
  }

  if (newspaperSubname === 'week' || newspaperSubname === 'woch' || newspaperSubname === 'sema') {
    return ['facebook', 'email'];
  }

  if (newspaperSubname === 'actu' || newspaperSubname === 'aeco' || newspaperSubname === 'mwne' || newspaperSubname === 'actuvideo') {
    return ['facebook','x','email','whatsapp'];
  }

  return [];
}
